import { render, staticRenderFns } from "./SmallLoader.vue?vue&type=template&id=0190a532&scoped=true&"
import script from "./SmallLoader.vue?vue&type=script&lang=js&"
export * from "./SmallLoader.vue?vue&type=script&lang=js&"
import style0 from "./SmallLoader.vue?vue&type=style&index=0&id=0190a532&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190a532",
  null
  
)

export default component.exports